export default __webpack_public_path__ + "static/media/flip-horizontal.b436ec47.svg";